type PaginatedResponseLike = { totalCount: number }

const fetchAllPages = async <R extends PaginatedResponseLike>(
  pageSize: number,
  fetchPage: (pageIndex: number) => Promise<R | null>
): Promise<R[]> => {
  const firstResponse = await fetchPage(0)
  if (!firstResponse) return []
  const totalPages = Math.ceil(firstResponse.totalCount / pageSize)
  const otherResponses = await Promise.all(
    Array.from({ length: Math.max(0, totalPages - 1) }, (_, i) => fetchPage(i + 1))
  )
  const nonNullOthers = otherResponses.filter((r) => r !== null) as R[]
  return [firstResponse, ...nonNullOthers]
}

export default fetchAllPages
